<template>
  <el-table :data="tableServerInfo" border :row-class-name="tableRowClassName">
    <el-table-column prop="ids" :label="$t('app.cardDetail.cardJftc.serialNumber')" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" :label="$t('app.cardDetail.cardJftc.orderNumber')" align="center" width="220"></el-table-column>
    <el-table-column prop="productName" align="center" width="220" :render-header="renderHeader"></el-table-column>
    <el-table-column prop="useFlowjia" :label="$t('app.cardDetail.cardJftc.usedFlow')" align="center" v-if="!adminShow"></el-table-column>
    <el-table-column prop="useFlow" :label="$t('app.cardDetail.cardJftc.usedFlow')" align="center" v-if="adminShow"></el-table-column>
    <el-table-column prop="monthFlow" :label="$t('app.cardDetail.cardJftc.totalFlow')" align="center"></el-table-column>
    <el-table-column prop="status" v-if="adminShow" :label="$t('app.cardDetail.cardJftc.packageStatus')" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.status == '未使用'" style="color: #1890ff;">{{ $t('app.cardDetail.cardJftc.status.unused') }}</span>
        <span v-else-if="scope.row.status == '使用中'" style="color: #52c41a;">{{ $t('app.cardDetail.cardJftc.status.inUse') }}</span>
        <span v-else-if="scope.row.status == '已使用'" style="color: #8c8c8c;">{{ $t('app.cardDetail.cardJftc.status.used')  }}</span>
        <span v-else-if="scope.row.status == '已过期'" style="color: #8c8c8c;">{{ $t('app.cardDetail.cardJftc.status.expired') }}</span>
        <span v-else-if="scope.row.status == '已转移'" style="color: #722ed1;">{{ $t('app.cardDetail.cardJftc.status.transferred')}}</span>
        <span v-else-if="scope.row.status == '已作废'" style="color: #f5222d;">{{ $t('app.cardDetail.cardJftc.status.invalid') }}</span>
        <span v-else>{{ scope.row.status }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="status" v-if="!adminShow" :label="$t('app.cardDetail.cardJftc.packageStatus')" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.status == '未使用'" >{{ $t('app.cardDetail.cardJftc.status.unused') }}</span>
        <span v-else-if="scope.row.status == '使用中'" >{{ $t('app.cardDetail.cardJftc.status.inUse') }}</span>
        <span v-else-if="scope.row.status == '已使用'" >{{ $t('app.cardDetail.cardJftc.status.used')  }}</span>
        <span v-else-if="scope.row.status == '已过期'" >{{ $t('app.cardDetail.cardJftc.status.expired') }}</span>
        <span v-else-if="scope.row.status == '已转移'" >{{ $t('app.cardDetail.cardJftc.status.transferred')}}</span>
        <span v-else-if="scope.row.status == '已作废'" >{{ $t('app.cardDetail.cardJftc.status.invalid') }}</span>
        <span v-else>{{ scope.row.status }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="startTime" :label="$t('app.cardDetail.cardJftc.startTime')" align="center"></el-table-column>
    <el-table-column prop="endTime" :label="$t('app.cardDetail.cardJftc.endTime')" align="center"></el-table-column>
    <el-table-column label="操作" align="center" width="200" v-if="adminShow && checkPermi(['card:info:activeProduct']) ">
      <template slot-scope="scope">
        <el-button size="mini" type="danger" v-if='!scope.row.startTime && scope.row.status =="未使用" ' @click="activatepackage(scope.row.orderNum)" style="background:#24D2B5;border: 1px solid #24D2B5;width:72px" v-hasPermi="['card:info:activeProduct']">激活套餐</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { cardProduct } from "@/api/api.js"; //资费列表
import { activeOrderInfo } from "@/api/api.js";//激活套餐
export default {
  props: {
    iccid: {
      type: [String]
    },
    labelTip: {
      type: [String],
      default: ''
    }

  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  computed: {
    adminShow () {
      return this.$store.getters.user.userType =='1'
    }
  },
  watch: {
    iccid() {
      this.initData();
    },
  },
  methods: {
    renderHeader(h, { column, $index }) {
      return h('div', [
        h('span', this.$t('app.cardDetail.cardJftc.packageName')),
        h('span', {
          style: {
            color: 'red',
            fontWeight: 'bold',
            fontSize: '16px',
            marginLeft: '10px'
          }
        }, this.labelTip)
      ])
    },
    tableRowClassName({ row }) {
      // 当状态为"使用中"时，返回高亮类名
      if (row.status === "使用中") {
        return "highlight-row";
      }
      return "";
    },
    Packagestatus(status) {
      let obj = {
        1: "未使用",
        2: "使用中",
        3: "已使用",
        4: "已过期",
        5: "已转移",
        6: "已作废",
      };
      return obj[status];
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    changeIccid(iccid){
      this.iccid = iccid;
    },
    // 获取列表的数据
    initData(){
      if(!this.iccid || this.iccid == ''){
        return;
      }
      let params = {
        iccid : this.iccid
      };
      cardProduct(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index)=>{
            item.ids = index + 1;
            item.status = this.Packagestatus(item.status);
            if(this.adminShow){
              if(item.monthFlow < 0){
                item.monthFlow = "畅享";
              }else{
                item.monthFlow = this.formatDecimal(item.monthFlow,2);
              }
              item.useFlow = this.formatDecimal(item.useFlow,2);
            }else{
              item.monthFlow = this.formatDecimal(item.monthFlow,2);
              if(item.monthFlow < 0){
                item.monthFlow = "畅享";
                item.useFlow = "畅享";
              }else{
                item.useFlow = this.formatDecimal(item.useFlow,2);
              };
              if(item.status == "已过期"){
                item.useFlowjia = item.monthFlow;
              }else{
                item.useFlowjia = item.useFlow;
              }
            }
          })
        }
      })
    },
    // 激活套餐
    activatepackage(row){
      this.$confirm('是否继续激活套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          orderNum:row,
          iccid:this.iccid
        }
        activeOrderInfo(params).then(res => {
          if (res.data.code == 200){
            this.initData();
            this.$message({
              type: 'success',
              message: '激活成功!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消激活'
        });          
      });
    }
  },
  created() {
    this.$nextTick(() => {
      this.initData();
    });
  }
};
</script>

<style scoped lang="less">
::v-deep .highlight-row {
  background-color: #f0f9eb !important; /* 浅绿色背景 */
}
</style>


